import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_logistics_doc_image_preview",
  ref: "LogisticsDocImagePreviewRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_add_sale_order_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "d-flex gap-4" }
const _hoisted_7 = { class: "indicator-label" }
const _hoisted_8 = { class: "indicator-progress" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle me-2" }, null, -1)
const _hoisted_10 = ["download", "href"]
const _hoisted_11 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_12 = { class: "svg-icon svg-icon-1" }
const _hoisted_13 = { class: "modal-body py-10 px-10" }
const _hoisted_14 = { class: "base64-image-wrapper" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("shipmentLabel.preview")), 1),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.searchParams.logistics_document_status == 0)
              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                  key: 0,
                  ref: "approveButton",
                  type: "button",
                  class: "btn btn-light-primary btn-sm",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveShipmentLabel()))
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.t("shipmentLabel.approve")), 1),
                  _createElementVNode("span", _hoisted_8, [
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.pleaseWait")), 1)
                  ])
                ])), [
                  [_directive_auth, { auth: ['update'] }],
                  [_vShow, !_ctx.loading]
                ])
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("a", {
              class: "btn btn-light-primary btn-sm",
              download: _ctx.searchParams.file_path_name,
              href: _ctx.base64Image
            }, [
              _createTextVNode(_toDisplayString(_ctx.t("shipmentLabel.downloadImage")), 1)
            ], 8, _hoisted_10)), [
              [_directive_auth, { auth: ['export'] }],
              [_vShow, !_ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              src: _ctx.base64Image,
              alt: "",
              class: "base64-image"
            }, null, 8, _hoisted_15)
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ])
    ])
  ], 512))
}